<template>
	<div id="myChart" style="width: auto;height:1000px;"></div>
</template>

<script>
	import echarts from "echarts";
	import japan from 'echarts/map/json/japan'

	export default {
		name: 'OrderMap',
		data() {
			return {
				item:[],
				visualMap:{
					min:'',
					max:'',
				}
			}
		},
		components: {
			echarts,
			japan
		},
		mounted() {
			this.getData();
		},
		methods: {
			getData(){
				this.httpPost({
					url: '/admin/analysis/orderMap',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.item = temp.data;
					this.visualMap.min = temp.visualMap.min.value;
					this.visualMap.max = temp.visualMap.max.value;
					console.log(temp)
					this.drawLine(); //执行下面的函数

				
				}).catch((err) => {})
			},
			drawLine() {
				// var i=0;
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart"));
				// 绘制图表
				echarts.registerMap('japan', japan) //注册

				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '地图订单分布',
						subtext: 'Japan',
						x: 'center',
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					// 提示框，鼠标移入
					tooltip: {
						show: true, //鼠标移入是否触发数据
						trigger: 'item', //出发方式
						formatter: '{b}<br/>订单数量：{c}'
					},
					visualMap: {
						show: true,
						min: this.visualMap.min,
						max: this.visualMap.max,
						right: 'right',
						top: 'top',
						text: ['高', '低'], // 文本，默认为数值文本
						calculable: true,
						seriesIndex: [0],
						hoverLink: true,
						inRange: {
							color: ['#fb714c', '#70b4f4', '#70e4f4', '#f09640', '#f9d9bb'], //颜色
							symbolSize: [60, 200],
						}
					},
					// geo: {
					//                   map: 'japan',
					//                   label: {
					//                       // 显示各个省份名称
					//                       emphasis: {
					//                           show: true,
					//                           color: '#fff'
					//                       }
					//                   },
					//                   roam: true,//禁止其放大缩小
					//                   itemStyle: {
					//                       normal: {
					//                           areaColor: 'rgb(79, 163, 213)',
					//                           borderColor: '#002097'
					//                       },
					//                       emphasis: {
					//                           areaColor: '#293fff'
					//                       }
					//                   }
					//               },
					series: [{
						name: '地图',
						type: 'map',
						map: 'japan',
						data: this.item,
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],


				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			}
		}
	}
</script>

<style>
</style>
